export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.18-1735.37',
  commitId: '3fd0fc462520653b5bfde70c89b480e22f79a65d',
  commitTime: '2026-02-18T17:35:37.000Z',
});
